import WidgetManager from "src/components/lobby-admin/WidgetManager";

const AddLobbyPage = () => {
  return <WidgetManager />;
};

export default AddLobbyPage;